import { gql } from '@apollo/client'

export const GET_UI_SETTINGS = gql`
  query GET_UI_SETTINGS {
    findManySetting {
      name
      title
      type
      value
      shopSettingId
      description
      __typename
    }
  }
`

export const UPDATE_UI_SETTINGS = gql`
  mutation UpdateOneShopSetting(
    $data: ShopSettingUpdateInput!
    $where: ShopSettingWhereUniqueInput!
  ) {
    updateOneShopSetting(data: $data, where: $where) {
      id
      __typename
    }
  }
`
